import React from 'react'
import styles from './VenuesSelectionCard.module.scss'

export default function VenuesSelectionCard({
	image,
	title,
	selected,
	onClick,
}) {
	return (
		<div
			onClick={onClick}
			className={`${styles.card} ${selected ? styles.selected : ''}`}
		>
			{/* Image */}
			<img src={image} alt={title} className={styles.image} />

			{/* Circle badge */}
			<div
				className={`${styles.badge} ${selected ? styles.badgeSelected : ''}`}
			>
				{selected && (
					<svg
						className={styles.checkIcon}
						fill="none"
						stroke="currentColor"
						strokeWidth="3"
						viewBox="0 0 24 24"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							d="M5 13l4 4L19 7"
						/>
					</svg>
				)}
			</div>

			{/* Bottom overlay */}
			{/* <div className={styles.overlay}>
				<h3>{title}</h3>
			</div> */}
		</div>
	)
}
